import { render } from "./IconRfidPowerMid.vue?vue&type=template&id=c13f715c"
import script from "./IconRfidPowerMid.vue?vue&type=script&lang=ts"
export * from "./IconRfidPowerMid.vue?vue&type=script&lang=ts"
script.render = render

export default script